import { render } from "./Menu.vue?vue&type=template&id=49cf100d"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=49cf100d&lang=scss"
script.render = render

export default script